const speakers = [
  // {
  //   name: "Jack Millington",
  //   company: "Billy Tannery",
  //   photo: {
  //     src: "/images/speakers/jack.jpg",
  //   },
  //   bio: "",
  //   website: "https://billytannery.co.uk/",
  //   social: {
  //     x: "https://twitter.com/billytannery",
  //     instagram: "https://www.instagram.com/billytannery/",
  //     linkedin: "https://www.linkedin.com/company/billy-tannery/",
  //     facebook: "https://www.facebook.com/billytannery/",
  //   },
  // },
  {
    name: "Jane Robertson",
    company: "Oak and Smoke Tannery",
    photo: {
      src: "/images/speakers/jane-robertson.webp",
    },
    bio: "Jane specialises in bark tanning of medium sized hides (eg sheep, deer and goat) using hand harvested locally available tree bark, mostly oak, spruce and willow, and more unusual experiments too. Through experience, trial and error, and learning from professionals in various countries, she has her own recipes which produce good quality leather. She also offers a service to people who wish to tan their own animals hides, with her open workshop teaching space. She has 10 years experience in teaching hide tanning, including hair on hides, bark tanning, brain tanning and rawhide.",
    website: "https://www.oakandsmoketannery.co.uk/",
    social: {
      instagram: "https://www.instagram.com/janejay.tanner",
      instagram2: "https://www.instagram.com/oak.and.smoke.tannery/",
      facebook: "https://www.facebook.com/profile.php?id=100064183653112",
    },
  },
  {
    name: "Alice Robinson",
    company: "British Pasture Leather",
    photo: {
      src: "/images/speakers/alice-robinson.webp",
      credit: "Daisy Wingate-Saul",
    },
    bio: 'Alice is the co-founder of British Pasture Leather, the first supply of leather traceable to regenerative farms in the UK. Her work sits at the intersection of food and fashion, exploring the shared systems and values that connect them. She is the author of "Field, Fork, Fashion", which documents the making of her 2019 design collection "Bullock 374", featured in the V&A Museum’s exhibition FOOD: Bigger than the Plate. Alice studied fashion at the Royal College of Art and is a Freeman of the Leathersellers\' Company.',
    website: "",
    social: {
      instagram: "https://www.instagram.com/british.pasture.leather",
      instagram2: "https://www.instagram.com/alice.v.robinson",
    },
  },
  {
    name: "Dr. Kerry Senior",
    company: "UK Leather",
    photo: {
      src: "/images/speakers/kerry-senior.webp",
    },
    bio: "Kerry is the director of Leather UK, the trade association for the UK leather industry, promoting and protecting the British industry. His role includes the secretariats of the Leather Producers’ Association, the Dr Dorothy Jordan Lloyd Memorial Trust and the British Industry Development Trust. In 2019, he became secretary of the International Council of Tanners, the international association for leather manufacturers.",
    website: "",
    social: {},
  },
  {
    name: "Nina Conrad",
    company: "regionales Leder",
    photo: {
      src: "/images/speakers/nina-conrad.webp",
    },
    bio: "Nina is a sustainability consultant with many years of experience in the textile and leather industries, specializing in traceable, regional leather supply chains. She develops and oversees leather production for both small and large companies, and supports stakeholders in the apparel, accessories, and footwear sectors as a consultant, product manager, and project lead. As co-founder and coordinator of Fibershed DACH, she is actively involved in projects and networks that promote regional, sustainable material use.",
    website: "",
    social: {},
  },
  {
    name: "Karl Flower",
    company: "Authenticae Ltd",
    photo: {
      src: "/images/speakers/karl-flower.webp",
    },
    bio: "Karl is the Technical Director at Authenticae Ltd. He started his tanning career with the Leather Industries Research Institute, LIRI (in South Africa). Karl has been a production manager of tanneries in South Africa. Karl’s research focusses on understanding the sustainability and biodegradability of leather and leather-like materials, with an active interest in life cycle analysis systems. Karl has been teaching and practising mass balance (since 2001) and LCA analysis of leather and allied products/service since 2015, including farm, chemicals, machines, and non-leather materials.",
    website: "",
    social: {},
  },
  {
    name: "Claire Beaumont",
    company: "",
    photo: {
      src: "/images/speakers/claire-beaumont.webp",
    },
    bio: "Claire farms with her husband and parents in the Lake District. She manages a herd of beef shorthorn cattle using regenerative practices. For the past 4 years she has been collecting her hides and more recently hides from other farmers in the Lake District from the abattoir and sending them away to be tanned and finished, with the support of British Pasture Leather. She now produces and sells luxury leather goods under the Parnassus brand, which focusses on traceability and sustainability, giving provenance to her products.",
    website: "",
    social: {},
  },
  {
    name: "Jessie Watson Brown",
    company: "Oak and Smoke Tannery",
    photo: {
      src: "/images/speakers/jessie-watson.webp",
    },
    bio: "Jessie runs a hand-scale micro-tannery on Dartmoor. She has been tanning for 11 years, mostly specialising in using local deer skins for leather, rugs, rawhides and buckskin. She runs courses in tanning, butchery and craft. Jessie's focus is on local, natural materials and relationship to place through the craft of tanning. She harvests (almost) all her bark by hand from local forestry. She currently has an apprentice, funded by The Leathersellers.",
    website: "https://www.oakandsmoketannery.co.uk/",
    social: {
      instagram: "https://www.instagram.com/rekindled.hearth",
      instagram2: "https://www.instagram.com/oak.and.smoke.tannery/",
      facebook: "https://www.facebook.com/profile.php?id=100064183653112",
    },
  },
  {
    name: "Hanna Nore",
    photo: {
      src: "/images/speakers/hanna-nore.webp",
    },
    bio: "Hanna is a master tanner, artisan, author and educator, and she is also working as Leather Tanning specialist for Finnish company called Boreal Bioproducts. Boreal Bioproducts transforms certified forestry side streams into sustainable, cost-competitive raw materials for the leather industry. \"Our goal is to return to our Northern roots,\" Hanna explains. \"The origins of sustainable leather tanning are right here, in the Finnish spruce forests. Through innovation and tradition, we have opened a door that the leather industry closed almost a century ago.\" Hanna is based on Kimito Island in the Finnish Archipelago, she has spent 22 years mastering the intricate art of traditional tanning, training hundreds of artisans, and sharing her knowledge through lectures across Finland and internationally. Hanna is also the author of two widely acclaimed books on leather tanning, available in both Finnish and English.",
    website: "https://traditionaltanning.com/",
    social: {
      instagram: "https://www.instagram.com/tanningbyhannanore/",
      instagram2: "https://www.instagram.com/traditionaltanningshop/",
      facebook: "https://www.facebook.com/TraditionalTanningShop/",
    },
  },
  {
    name: "James Allen",
    company: "Cotmarsh Tannery CIC",
    photo: {
      src: "/images/speakers/james-allen.webp",
    },
    bio: "James and his wife Katie farm Great Cotmarsh Farm in Wiltshire, managing for wildlife and nature with Organic, pasture-fed rare breed cows and sheep. In 2025 James set up Cotmarsh Tannery CIC as a not-for-profit education tannery after traveling to 12 tanneries across 4 countries as part of a Churchill Fellowship.",
    website: "https://cotmarshtannery.co.uk/",
    social: {
      instagram: "https://www.instagram.com/cotmarshtannery/",
      linkedin: "https://www.linkedin.com/company/cotmarshtannery/",
      facebook: "https://www.facebook.com/cotmarshtannery/",
    },
  },
  // {
  //   name: "",
  //   company: "",
  //   photo: {
  //      src: "/images/speakers/placeholder.webp",
  //      credit: "",
  //   },
  //   bio: "",
  //   website: "",
  //   social: {
  //     x: "",
  //     instagram: "",
  //     linkedin: "",
  //     facebook: "",
  //   },
  // },
];

export default speakers;
